import { match } from 'path-to-regexp';
import isLocal from './isLocal';

/**
 * Determines if the current page can be discovered for recording purposes.
 *
 * @param recordingBlocklist - List of path patterns that should not be recorded
 * @param allowLocalhostRecording - Override to allow recording on localhost/127.0.0.1
 * @returns boolean - true if the current page can be discovered, false otherwise
 */
export default function canDiscover(
  recordingBlocklist: string[],
  allowLocalhostRecording?: boolean
): boolean {
  if (isLocal() && !allowLocalhostRecording) {
    return false;
  }

  const currentPath = window.location.pathname;

  for (const pattern of recordingBlocklist) {
    try {
      const matchFn = match(pattern, { decode: decodeURIComponent });
      if (matchFn(currentPath)) {
        return false;
      }
    } catch (e) {
      // If pattern is not valid for path-to-regexp, try exact match
      if (pattern === currentPath) {
        return false;
      }
    }
  }

  return true;
}
